import PlayArrowImg from "./Vector.png";

const { default: styled } = require("styled-components");
const { Player } = require("video-react");

export const StyledPlayer = styled(Player)`
  font-family: IRANSans !important;
  padding-top: 0 !important;
  height: 100% !important;
  
  & .video-react.video-react-fluid {
  }
  .video-react {
    font-size: 1em;
    background-color: #000;
  }

  .video-react .video-react-control {
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .video-react .video-react-control:hover {
    background-color: rgba(0, 0, 0, 0.7);
  }

  .video-react .video-react-control:active {
    background-color: rgba(0, 0, 0, 0.9);
  }

  .video-react .video-react-control:focus {
    box-shadow: 0 0 0 2px #fff;
  }

  .video-react-big-play-button {
    width: 70px;
    height: 70px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff80;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    &:before {
      content: url(${PlayArrowImg});
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-47%, -35%);
    }
  }

  & .video-react-poster {
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  & .video-react-loading-spinner {
    &:after {
      left: 0;
    }
    &:before {
      left: 0;
    }
  }

  & .video-react-control-bar {
    direction: ltr;
  }
`;
